import React from 'react'
import { navigate } from 'gatsby'

import icon_instagram from '../../../assets/images/icon-instagram.png'
import Button from '../../atoms/button/button'

import { pushEventData } from '../../../utils/pushEventDataLayer'

import './footerHomeSection.scss'
import Show from '../../../utils/show'
import { LOCALE, TROPICALIZED } from '../../../constants/activity-constants'

const FooterHomeSection = () => {
  const urlRedirect = {
    'es-CO': 'https://www.instagram.com/nosotras/',
    'es-PE': 'https://www.instagram.com/nosotrasperu/',
    'es-EC': 'https://www.instagram.com/nosotrasecuador/',
    'es-CL': 'https://www.instagram.com/nosotraschile/',
    'es-DO': 'https://www.instagram.com/nosotrasrd/',
    'es-PR': 'https://www.instagram.com/nosotraspr/',
    'es-BO': 'https://www.instagram.com/nosotrasbolivia/',
  }[LOCALE || 'es-CO']

  return (
    <section className="f-footerHomeSection-container">
      <div className="f-footerHomeSection-container__infoText">
        <img src={icon_instagram} alt="icono visualizacion de instagram" />
        <p>
          <Show valid={TROPICALIZED}>
            <b>¿Ya conocés nuestro calendario de adviento?</b> Corré a nuestro
            Instagram y descubrí los regalos que tenemos para vos.
          </Show>
          <Show valid={TROPICALIZED === false}>
            <b>¿Ya conoces nuestro Calendario de adviento? </b> Corre a nuestro
            Instagram y descubre los regalos que tenemos para ti
          </Show>
        </p>
        <Button
          text="¡Allá voy!"
          onClick={() => window.open(urlRedirect, '_blank')}
          metric={{
            event: 'Interacciones_Home_Navidad',
            category: 'Navidad',
          }}
        />
      </div>
      <a
        onClick={() => {
          navigate('/terms')
          pushEventData({
            event: 'Interacciones_Home_Navidad',
            category: 'Navidad',
            label: 'Terminos y condiciones',
          })
        }}
        className="f-footerHomeSection-container__tyc"
      >
        Términos y condiciones de la actividad
      </a>
    </section>
  )
}

export default FooterHomeSection
